<script>
import StrDataSelectTypeSelect from "@/views/DataSelect/Components/StrDataSelectTypeSelect.vue";

export default {
    components: {StrDataSelectTypeSelect},
    props: {
        filter: {
            type: Object,
            required: true,
        },
        showType: Boolean
    }
};
</script>

<template>
    <div>
        <v-row>
            <v-col cols="12" sm="6" md="3">
                <w-text-field v-model="filter.name" :label="`${$t('common.name')}`"/>
            </v-col>
            <v-col cols="12" sm="6" md="3" v-if="showType">
                <StrDataSelectTypeSelect v-model="filter.stringType" open-all :label="$t('data_select.type')"/>
            </v-col>
        </v-row>
    </div>
</template>